<template>
<div>
  <el-row class="crm-site"
    :style="{'padding-top': !userInfo.ranking?'46px':'120px'}">
    <div v-if="userInfo.haveBirthdayPrivilege">
      <el-col :style="{'margin-top': '20px'}">
        <BirthdayCard />
      </el-col>
    </div>
    <el-col class="crm-site-content">
      <div v-if="!isDisableCrm" class="crm-flex-left">
        <img
          height="18px"
          width="20px"
          :src="require('@/assets/icons/couponblack.png')"
          alt=""
        />&nbsp;
        <label class="crm-reward-text">{{ $t('promotion-detail.deals') }}</label>
      </div>
      <PromotionDrawer/>
    </el-col>
    <!-- Open CRM Flag -->
    <div v-if="isLoading">
      <el-col>
        <PromotionCard isLoading />
        <PromotionCard isLoading />
        <PromotionCard isLoading />
      </el-col>
    </div>
    <!-- Close CRM Flag -->
    <div v-else-if="isDisableCrm || branchInfo.disabledFlag || !branchInfo.fsCrmEnable">
      <el-col>
        <nothing-to-see-here
          useImg="crm-close.png"
          :mainText="$t('components.coupon.branch-closed')"
          :subText="$t('components.coupon.sorry-inconvenience')"
        />
        <el-row style="text-align: center;margin-top: 32px;">
          <el-button class="white-btn" @click="onClickSwitchBranch">
            <span>
              <restaurant style="margin: 0 8px 2px 0;" />
              {{$t('components.coupon.select-branch')}}
            </span>
          </el-button>
        </el-row>
      </el-col>
    </div>
    <div v-else-if="!(isDisableCrm || isError)">
      <!-- Promotion List -->
      <el-col v-if="promotionList && promotionList.length > 0">
        <PromotionCard
          v-for="(promo, index) in promotionList"
          :key="index"
          :promotion="promo"
          @click.native="handlerPromotionList(index)"
        />
      </el-col>
      <!-- No Promotion List -->
      <el-col v-else>
        <nothing-to-see-here
          useImg="no-reward.png"
          :mainText="$t('components.promotion.no-list')"
          :subText="$t('components.promotion.please-follow')"
        />
      </el-col>
    </div>
    <!-- Error -->
    <div v-else>
      <el-col>
        <nothing-to-see-here
          useImg="oops-error.webp"
          :mainText="$t('history.sorry')"
          :subText="$t('history.unable-retrieve')"
          @click-reload="fetchPromotionList"
          haveReloadBtn
        />
      </el-col>
    </div>
  </el-row>
  <branch-list
      :visible="showDrawerSwitchBranch"
      @onCloseDrawerSwitchBranch="onCloseDrawerSwitchBranch"
    />
</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PromotionCard from "@/components/promotion/PromotionCard";
const PromotionDrawer = () => import("@/components/promotion/PromotionDrawer.vue");
import BirthdayCard from "@/components/promotion/BirthdayCard";
const NothingToSeeHere = () => import("@/components/NothingToSeeHere.vue");
import GATracking from "@/helper/GATrackingMixins";
const BranchList = () => import("@/components/home/BranchList.vue");
const Restaurant = () => import("@/assets/svg/restaurant.svg")

export default {
  components: {
    PromotionCard,
    NothingToSeeHere,
    BirthdayCard,
    BranchList,
    Restaurant,
    PromotionDrawer
  },
  mixins: [GATracking],
  data() {
    return {
      isLoading: false,
      isError: false,
      isDisableCrm: false,
      showDrawerSwitchBranch: false,
    };
  },
  async mounted() {
    this.fetchPromotionList();
  },
  methods: {
    ...mapActions({
      fetchPromotionListAction: "promotion/fetchPromotionList",
      setPromotionDetail: "promotion/setPromotionDetail",
    }),
    handlerPromotionList(index) {
      this.trackActivity(4, 'RedeemCRMPromotion');
      this.setPromotionDetail(this.promotionList[index]);
    },
    fetchPromotionList() {
      this.isLoading = true;
      this.fetchPromotionListAction(this.branchUUID)
        .then(() => {
          this.isError = null;
        })
        .catch((error) => {
          if (error.isDisableCrm) this.isDisableCrm = error.isDisableCrm;
          else this.isError = error;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onClickSwitchBranch() {
      this.trackActivity(3, 'CRMPromotionList');
      this.showDrawerSwitchBranch = true;
    },
    onCloseDrawerSwitchBranch() {
      this.showDrawerSwitchBranch = false;
    },
  },
  computed: {
    ...mapGetters({
      branchInfo: "branch/branchInfo",
      branchUUID: "branch/branchUUID",
      promotionList: "promotion/promotionList",
      userInfo: "user/userInfo"
    }),
  },
};
</script>

<style scoped>
.crm-site {
  background-color: var(--background-color);
  margin-bottom: 60px;
  padding: 16px;
  padding-top: 46px;
  overflow-y: auto;
  min-height: calc(100vh - 168px - 60px);
}

.crm-site-content {
  padding: 20px 10px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
}

.crm-reward-text {
  color: #4f4f4f;
  font-size: 18px;
  font-weight: lighter;
  line-height: 1.2rem;
  margin-left: 5px;
}

.crm-flex-left {
  display: flex;
  justify-content: left;
}

.crm-flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40vh;
}

.crm-empty-reward {
  font-size: 24px;
  color: #4d5078;
  font-weight: 400;
  position: absolute;
  margin-top: 290px;
}

.crm-restaurant-news {
  font-size: 18px;
  color: #828282;
  font-weight: 400;
  position: absolute;
  margin-top: 330px;
}
.white-btn{
    background: #FFFFFF;
    border: 0.5px solid #DFE1E6;
    box-shadow: 0px 4px 14px rgba(106, 113, 128, 0.1);
    border-radius: 8px;
    height: 40px;
    color: #4D5078;
    padding: 8px 22px;
}
.white-btn span{
  display: flex;
    align-items: center;
}
</style>